import { useCallback, useState } from 'react';

import { DEFAULT_TRANSFER_LIST_ITEM_SIZE } from '../constants.ts';

/**
 * Tracks measured row heights for variable-size lists.
 * In react-window v2, updating this map (immutably) invalidates List layout —
 * replacing the old `resetAfterIndex` imperative API.
 */
export const useTransferListItemSizes = () => {
  const [itemSizes, setItemSizes] = useState<Record<string, number>>({});

  const setItemSize = useCallback((index: number, size: number) => {
    setItemSizes(prev => {
      if (prev[index] === size) {
        return prev;
      }

      return { ...prev, [index]: size };
    });
  }, []);

  // Stable between measurements so List does not rebuild its row offset cache on every render
  const getItemSize = useCallback((index: number) => itemSizes[index] || DEFAULT_TRANSFER_LIST_ITEM_SIZE, [itemSizes]);

  return {
    getItemSize,
    itemSizes,
    setItemSize,
  };
};
